import { Link } from "react-router-dom";
import { podeAlterarRegisto } from "../../../../../shared/util/unidadeRegisto";
import "./Tooltip.scss";

const Tooltip = ({
  event,
  handleApagarAgendamento,
  handleMoverAgendamento,
  onClose,
  auth,
}) => {
  /* Marcação de outra unidade: vê-se, não se mexe.
   *
   * Eliminar ou mover daqui alteraria a agenda do outro balcão — e quem lá
   * está não daria por nada. A agenda pode mostrar as duas unidades quando se
   * escolhe «todas», e é aí que isto conta.
   *
   * Tolerante por construção, como o resto: sessão sem unidade ou marcação sem
   * unidade deixam passar. */
  const daMinhaUnidade = podeAlterarRegisto(
    event.extendedProps?.estabelecimento,
    auth,
  );

  const canDelete =
    daMinhaUnidade &&
    !event.extendedProps.isAttended &&
    !event.extendedProps.isMissed;

  const canMove =
    daMinhaUnidade &&
    !event.extendedProps.isAttended &&
    !event.extendedProps.isMissed &&
    !event.extendedProps.isAgendamentoProvisorio &&
    !event.extendedProps.listaEsperaId;

  const handleBeforeApagarAgendamento = (event) => {
    handleApagarAgendamento(event);
    onClose();
  };

  const handleBeforeMoverAgendamento = (event) => {
    handleMoverAgendamento(event);
    onClose();
  };

  return (
    <div className="tooltip">
      {!event.extendedProps.isCompromisso && (
        <>
          <div className="tooltip__userNameProcedure">
            <svg
              className="tooltip__userNameProcedure__svg"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"></path>
            </svg>
            <div className="tooltip__userNameProcedure__nameProcedureContainer">
              <span className="tooltip__userNameProcedure__name">
                <Link
                  to={`/clientes/${event.extendedProps.clientId}`}
                  className="tooltip__client-link"
                >
                  {event.title.split(" - ")[0]}
                </Link>
              </span>
              <span className="tooltip__userNameProcedure__procedure">
                #{" "}
                {event.extendedProps.isEvaluation
                  ? "Avaliação"
                  : event.extendedProps.inTransition
                    ? "Transição"
                    : event.extendedProps.isTratamentoIsolado
                      ? "Tratamento Isolado"
                      : event.extendedProps.isAgendamentoProvisorio
                        ? "Agendamento Provisório"
                        : !event.extendedProps.isCompromisso &&
                          `${
                            event.extendedProps.isOrcamento
                              ? "Orçamento"
                              : "Procedimento"
                          }`}
              </span>
            </div>
          </div>

          <div className="tooltip__precedureInfo">
            <span className="tooltip__precedureInfo__title">Procedimento</span>
            <span className="tooltip__precedureInfo__procedimentoName">
              {event.title.split(" - ")[1]}
            </span>
            <span className="tooltip__precedureInfo__title">Estado</span>
            <div className="tooltip__precedureInfo__procedimentoStatus">
              <span
                style={{
                  backgroundColor: event.extendedProps.isAttended
                    ? "#F2FAF5"
                    : event.extendedProps.isMissed
                      ? "#FFF3F6"
                      : "#fff7eb",
                  color: event.extendedProps.isAttended
                    ? "#39B93A"
                    : event.extendedProps.isMissed
                      ? "#D96C60"
                      : "#fdcb7f",
                }}
              >
                {event.extendedProps.isAttended
                  ? "Atendido"
                  : event.extendedProps.isMissed
                    ? "Faltou"
                    : "Pendente"}
              </span>
            </div>
          </div>
        </>
      )}

      {event.extendedProps.isCompromisso && (
        <>
          <span className="tooltip__title">Compromisso</span>
          <span className="tooltip__description">{event.title}</span>
        </>
      )}

      <div className="tooltip__dataAtendimento">
        <svg
          className="tooltip__dataAtendimento__svg"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="#000000"
          viewBox="0 0 256 256"
        >
          <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z"></path>
        </svg>

        <span className="tooltip__dataAtendimento__data">
          {`${event.start.getDate()} ${event.start.toLocaleDateString("pt-BR", {
            month: "long",
          })} ${event.start.getFullYear()},`}
        </span>
        <span className="tooltip__dataAtendimento__data">
          {event.start?.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })}{" "}
          -{" "}
          {event.end?.toLocaleTimeString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          })}
        </span>
      </div>

      <div className="tooltip__agendadoPor">
        <span className="tooltip__agendadoPor__title">Agendado por:</span>
        <span className="tooltip__agendadoPor__value">
          {event.extendedProps.agendadoPor}
        </span>
      </div>

      <div className="tooltip__agendadoPor">
        <span className="tooltip__agendadoPor__title">Observações:</span>
        <span className="tooltip__agendadoPor__value">
          {event.extendedProps.observacoesAgendamento
            ? event.extendedProps.observacoesAgendamento
            : "Nenhuma Observação"}
        </span>
      </div>

      <div className="tooltip__actions">
        {auth.role === "Secretária(o)" &&
          auth.usuariosAssociados.length > 1 &&
          canMove && (
            <div
              className="tooltip__action-btn tooltip__action-btn--move"
              onClick={handleBeforeMoverAgendamento.bind(null, event)}
            >
              <svg
                className="tooltip__action-btn__svg tooltip__action-btn__svg--move"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#000000"
                viewBox="0 0 256 256"
              >
                <path d="M224,120v64a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V120a16,16,0,0,1,16-16H208A16,16,0,0,1,224,120ZM48,88H208a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16ZM208,56H48a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z"></path>
              </svg>

              <span>Mover</span>
            </div>
          )}

        {canDelete && auth.perm.includes("d-marc") && (
          <div
            className="tooltip__action-btn tooltip__action-btn--delete"
            onClick={handleBeforeApagarAgendamento.bind(null, event)}
          >
            <svg
              className="tooltip__action-btn__svg tooltip__action-btn__svg--delete"
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="#000000"
              viewBox="0 0 256 256"
            >
              <path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path>
            </svg>

            <span>Excluir</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Tooltip;
